import React, { useState, useEffect } from "react";
import { Card } from "antd";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { toast } from "react-hot-toast";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api from "../interceptors/api";
import StandardButton from "../components/StandardButton";

const sampleInput = "Hello\\nWorld\\nLine 3\\nLine 4\\nLine 5\\nLine 6";

const RenderString = () => {
  const [input, setInput] = useState(sampleInput);
  const [output, setOutput] = useState("");
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();

  useEffect(() => {
    const id = searchParams.get("share");
    if (id) {
      api.get(`/render-string/share/${id}`)
        .then(res => {
          const data = res.data;
          if (data.input && data.output) {
            setInput(data.input);
            setOutput(data.output);
          }
        })
        .catch(() => {
          toast.error(t('server_error'));
        });
    }
  }, []);

  const handleRender = () => {
    const formatted = input.replace(/\\n/g, "\n");
    setOutput(formatted);
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(output);
      toast.success(t('copy_success'));
    } catch {
      toast.error(t('failed_to_copy'));
    }
  };

  const handleShare = async () => {
    try {
      const res = await api.post(`/render-string/share`, { input, output });
      const data = res.data;
      if (data.id) {
        const url = `${window.location.origin}/tools/render-string?share=${data.id}`;
        await navigator.clipboard.writeText(url);
        toast.success(t('share_success'));
      } else {
        toast.error(t('share_failed'));
      }
    } catch {
      toast.error(t('share_failed'));
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-indigo-50 to-white p-0 text-gray-800">
      <Header />
      <div className="max-w-5xl mx-auto">
        <Card className="shadow-lg rounded-xl">
          <div className="p-4 flex flex-col gap-4">
            <textarea
              rows={6}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-400 focus:outline-none"
              placeholder={t('render_string_placeholder')}
              value={input}
              onChange={(e) => setInput(e.target.value)}
            />

            <StandardButton
              onClick={handleRender}
              type="secondary"
              className="w-full"
            >
              {t('render_button')}
            </StandardButton>

            {output && (
              <div className="bg-indigo-50 p-4 rounded-md border border-indigo-200 whitespace-pre-wrap relative">
                <strong className="text-indigo-700">{t('output')}:</strong>
                <p className="break-all mt-2 text-gray-800">{output}</p>
                <div className="mt-2 flex gap-3">
                  <StandardButton
                    onClick={handleCopy}
                    type="secondary"
                    variant="outlined"
                    size="small"
                  >
                    {t('copy_button')}
                  </StandardButton>
                  <StandardButton
                    onClick={handleShare}
                    type="secondary"
                    variant="outlined"
                    size="small"
                  >
                    {t('share_button')}
                  </StandardButton>
                </div>
              </div>
            )}
          </div>
        </Card>
      </div>
      <Footer />
    </div>
  );
};

export default RenderString;